Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buttonTypes = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports['default'] = DOMButtonOrA;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _idProp = require('../utils/propTypes/idProp');

var _idProp2 = _interopRequireDefault(_idProp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var buttonTypes = exports.buttonTypes = {
  button: 'button',
  submit: 'submit'
};

var propTypes = {
  // DOMButtonOrA is unique case when we want to pass around className and styles (DO NOT COPY)
  className: _propTypes2['default'].string,
  style: _propTypes2['default'].any, // eslint-disable-line react/forbid-prop-types
  id: _idProp2['default'],
  children: _propTypes2['default'].node,
  type: _propTypes2['default'].oneOf(Object.keys(buttonTypes)),
  href: _propTypes2['default'].string,
  openInNewWindow: _propTypes2['default'].bool,
  role: _propTypes2['default'].string,
  disabled: _propTypes2['default'].bool,
  onClick: _propTypes2['default'].func,
  onFocus: _propTypes2['default'].func,
  onBlur: _propTypes2['default'].func,
  onMouseDown: _propTypes2['default'].func,
  onMouseUp: _propTypes2['default'].func,
  onMouseEnter: _propTypes2['default'].func,
  onMouseLeave: _propTypes2['default'].func,
  onDragStart: _propTypes2['default'].func,
  onDragEnd: _propTypes2['default'].func,
  ariaLabel: _propTypes2['default'].string,
  ariaSelected: _propTypes2['default'].bool,
  ariaDescribedBy: _idProp2['default'],
  ariaDisabled: _propTypes2['default'].bool,
  ariaHasPopup: _propTypes2['default'].bool,
  ariaExpanded: _propTypes2['default'].bool,
  ariaControls: _propTypes2['default'].string,
  ariaPressed: _propTypes2['default'].bool,
  removeOutlineOnPress: _propTypes2['default'].bool,
  ampVarsClickType: _propTypes2['default'].string,
  ampReplace: _propTypes2['default'].string,
  itemProp: _propTypes2['default'].string,
  loading: _propTypes2['default'].bool,
  buttonAnchorRef: _propTypes2['default'].func,
  velouteId: _propTypes2['default'].string
};

var defaultProps = {
  className: null,
  style: null,
  id: undefined,
  children: null,
  type: buttonTypes.button,
  href: null,
  openInNewWindow: false,
  role: null,
  disabled: null,
  onClick: null,
  onFocus: null,
  onBlur: null,
  onMouseDown: null,
  onMouseUp: null,
  onMouseEnter: null,
  onMouseLeave: null,
  onDragStart: null,
  onDragEnd: null,
  ariaLabel: undefined,
  ariaSelected: undefined,
  ariaDescribedBy: undefined,
  ariaDisabled: false,
  ariaHasPopup: false,
  ariaExpanded: undefined,
  ariaControls: undefined,
  ariaPressed: undefined,
  removeOutlineOnPress: false,
  ampVarsClickType: undefined,
  ampReplace: undefined,
  itemProp: undefined,
  loading: false,
  buttonAnchorRef: function () {
    function buttonAnchorRef() {}

    return buttonAnchorRef;
  }(),

  velouteId: undefined
};

/*
DOMButtonOrA component provides accessible implementation of a clickable
element that takes href and onClick properties. If `href` prop is provided,
element will be rendered in DOM as `<a />`, otherwise as `<button />`.
*/
function DOMButtonOrA(_ref) {
  var className = _ref.className,
      style = _ref.style,
      id = _ref.id,
      children = _ref.children,
      type = _ref.type,
      href = _ref.href,
      openInNewWindow = _ref.openInNewWindow,
      role = _ref.role,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      onFocus = _ref.onFocus,
      onBlur = _ref.onBlur,
      onMouseDown = _ref.onMouseDown,
      onMouseUp = _ref.onMouseUp,
      onMouseEnter = _ref.onMouseEnter,
      onMouseLeave = _ref.onMouseLeave,
      onDragStart = _ref.onDragStart,
      onDragEnd = _ref.onDragEnd,
      ariaLabel = _ref.ariaLabel,
      ariaSelected = _ref.ariaSelected,
      ariaDescribedBy = _ref.ariaDescribedBy,
      ariaDisabled = _ref.ariaDisabled,
      ariaHasPopup = _ref.ariaHasPopup,
      ariaExpanded = _ref.ariaExpanded,
      ariaControls = _ref.ariaControls,
      ariaPressed = _ref.ariaPressed,
      removeOutlineOnPress = _ref.removeOutlineOnPress,
      ampVarsClickType = _ref.ampVarsClickType,
      ampReplace = _ref.ampReplace,
      itemProp = _ref.itemProp,
      loading = _ref.loading,
      buttonAnchorRef = _ref.buttonAnchorRef,
      velouteId = _ref.velouteId,
      otherProps = _objectWithoutProperties(_ref, ['className', 'style', 'id', 'children', 'type', 'href', 'openInNewWindow', 'role', 'disabled', 'onClick', 'onFocus', 'onBlur', 'onMouseDown', 'onMouseUp', 'onMouseEnter', 'onMouseLeave', 'onDragStart', 'onDragEnd', 'ariaLabel', 'ariaSelected', 'ariaDescribedBy', 'ariaDisabled', 'ariaHasPopup', 'ariaExpanded', 'ariaControls', 'ariaPressed', 'removeOutlineOnPress', 'ampVarsClickType', 'ampReplace', 'itemProp', 'loading', 'buttonAnchorRef', 'velouteId']);

  var isButton = !href || disabled;

  var mouseUpHandler = onMouseUp || removeOutlineOnPress ? function (e) {
    if (removeOutlineOnPress) {
      // Remove focus ring on buttons after clicking, but not when keyboard
      // tabbing around.
      e.currentTarget.blur();
    }
    if (onMouseUp) {
      onMouseUp(e);
    }
  } : null;

  var dataAttrProps = Object.entries(otherProps).filter(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 1),
        prop = _ref3[0];

    return prop.startsWith('data-');
  }).reduce(function (props, _ref4) {
    var _ref5 = _slicedToArray(_ref4, 2),
        key = _ref5[0],
        value = _ref5[1];

    return Object.assign({}, props, _defineProperty({}, key, value));
  }, {});
  var sharedProps = {
    className: className,
    style: style,
    id: id,
    role: role,
    onClick: onClick,
    onFocus: onFocus,
    onBlur: onBlur,
    onMouseDown: onMouseDown,
    onMouseUp: mouseUpHandler,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    onDragStart: onDragStart,
    onDragEnd: onDragEnd,
    'aria-label': ariaLabel,
    'aria-selected': ariaSelected,
    'aria-describedby': ariaDescribedBy,
    'aria-disabled': ariaDisabled ? true : undefined,
    'aria-haspopup': ariaHasPopup ? true : undefined,
    'aria-expanded': ariaExpanded,
    'aria-controls': ariaControls,
    'aria-busy': loading,
    'data-vars-click-type': ampVarsClickType,
    'data-amp-replace': ampReplace,
    'data-veloute': velouteId,
    itemProp: itemProp
  };

  if (isButton) {
    /* eslint react/button-has-type: 1 */
    return _react2['default'].createElement(
      'button',
      _extends({
        type: type,
        disabled: disabled || loading,
        ref: buttonAnchorRef,
        'aria-pressed': ariaPressed
      }, sharedProps, dataAttrProps),
      children
    );
  }

  return _react2['default'].createElement(
    'a',
    _extends({
      href: href,
      target: openInNewWindow ? '_blank' : null,
      rel: openInNewWindow ? 'noopener noreferrer' : null,
      ref: buttonAnchorRef
    }, sharedProps, dataAttrProps),
    children
  );
}

DOMButtonOrA.componentCategory = 'Private';
DOMButtonOrA.displayName = 'DOMButtonOrA';
DOMButtonOrA.propTypes = propTypes;
DOMButtonOrA.defaultProps = defaultProps;
DOMButtonOrA.buttonTypes = buttonTypes;


//////////////////
// WEBPACK FOOTER
// ./~/airbnb-dls-web/build/private/DOMButtonOrA.js
// module id = 121
// module chunks = 168707334958949